module.exports = __webpack_public_path__ + "static/media/cdap_2020_b.a66417a4.svg";